var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row pfol" }, [
    _c("div", { staticClass: "pfol__header small-12" }, [
      _vm._v("\n    " + _vm._s(_vm.$t("tenantProjects.guideline")) + "\n  "),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "small-12" },
      [
        _c("PostFitOutGuideline", {
          staticClass: "pfol__body",
          class: {
            "has-access": _vm.curReviewerWithAccess,
            "read-only": !_vm.curReviewerWithAccess,
          },
          attrs: { guidelines: _vm.parsedGuidelines, expand: true },
          scopedSlots: _vm._u(
            [
              _vm.curReviewerWithAccess
                ? {
                    key: "itemAction",
                    fn: function (slotProps) {
                      return [
                        _c("input", {
                          key:
                            slotProps.sectionItem.id +
                            "_" +
                            slotProps.sectionItem.checked,
                          staticClass: "hkl-guideline__checkbox",
                          attrs: {
                            id: slotProps.sectionItem.id,
                            type: "checkbox",
                            disabled: slotProps.sectionItem.disabled,
                          },
                          domProps: { checked: slotProps.sectionItem.checked },
                          on: {
                            change: function (event) {
                              return _vm.triggerGuideline(
                                event,
                                slotProps.section,
                                slotProps.sectionItem
                              )
                            },
                          },
                        }),
                      ]
                    },
                  }
                : null,
            ],
            null,
            true
          ),
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }